import { Backdrop, CircularProgress } from '@mui/material'

export default (props) => {
  return (
    <Backdrop open={props.open} style={{zIndex: 100}}>
      <CircularProgress style={{zIndex: 102}} color='secondary' />
    </Backdrop>
  )
}
